import { render } from "./3SearchPage.vue?vue&type=template&id=e29d182a&ts=true"
import script from "./3SearchPage.vue?vue&type=script&lang=ts"
export * from "./3SearchPage.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\nyaho\\Documents\\Code Works\\AWebsiteRepositories\\VortexByReflex-Main\\Reflex-Repo\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__